export default __webpack_public_path__ + "static/media/rugsOriginalUi@2x.c84294bb.png";